import { render, staticRenderFns } from "./SystemDetail.vue?vue&type=template&id=a17ab542&scoped=true"
import script from "./SystemDetail.vue?vue&type=script&lang=js"
export * from "./SystemDetail.vue?vue&type=script&lang=js"
import style0 from "./SystemDetail.vue?vue&type=style&index=0&id=a17ab542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17ab542",
  null
  
)

export default component.exports